import React, { useCallback, useRef } from "react";
import PropTypes from "prop-types";
import {
  HtmlEditor,
  Image,
  Inject,
  Table,
  Link,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar,
} from "@syncfusion/ej2-react-richtexteditor";
import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from "@syncfusion/ej2-react-navigations";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";
import ChangeLogIndividualListComponent from "./ChangeLogIndividualListComponent";
import Tools from "./JNSTools";
import "./styles/Requirements.css";

function RequirementsEditor(props) {
  //let rteRef = useRef();

  const tabComponentRef = useRef();
  const itemsArray = [
    "Bold",
    "Italic",
    "Underline",
    "StrikeThrough",
    "|",
    "FontName",
    "FontSize",
    "FontColor",
    "BackgroundColor",
    "|",
    "Formats",
    "Alignments",
    "OrderedList",
    "UnorderedList",
    "|",
    "CreateLink",
    "Image",
    "CreateTable",
    "|",
    "Undo",
    "Redo",
    "FullScreen",
  ];
  const toolbarSettings = { items: itemsArray };

  const leftJustify = useCallback((rteRef) => {
    if (rteRef !== null) {
      console.log(tabComponentRef.current);
      if (!rteRef.value && tabComponentRef.current.selectedItem == 0) {
        try {
          rteRef.executeCommand("justifyLeft");
        } catch (e) {
          console.log("ERR in RequirementsEditor.js: " + e.stack);
        }
      }
    }
  }, []);

  const tab1Content = () => {
    return (
      <Box height="300px" border="solid 3px">
        <RichTextEditorComponent
          ref={leftJustify}
          change={props.handleEditorContentsChange}
          value={props.reqDetails ? props.reqDetails : null}
          toolbarSettings={toolbarSettings}
          placeholder="Details..."
          height="300px"
        >
          <Inject
            services={[Toolbar, Image, Link, Table, HtmlEditor, QuickToolbar]}
          />
        </RichTextEditorComponent>
      </Box>
    );
  };

  /*useEffect(() => {
    if (rteRef.current) {
      rteRef.current.executeCommand("justifyLeft");
    }
  }, [rteRef.current]);*/

  const diffStyles = {
    contentText: {
      fontFamily: "Roboto",
      textAlign: "left",
    },
  };

  const tab2Content = () => {
    return (
      <Box height="300px" border="solid 3px" overflow="auto">
        <ReactDiffViewer
          oldValue={Tools.removeTags(props.prevDetails)}
          newValue={Tools.removeTags(props.reqDetails)}
          styles={diffStyles}
          compareMethod={DiffMethod.WORDS}
          splitView={true}
          //showDiffOnly={true}
          //extraLinesSurroundingDiff={0}
        />
      </Box>
    );
  };

  const tab3Content = () => {
    return (
      <ReactDiffViewer
        oldValue={Tools.removeTags(props.prevDetails)}
        newValue={Tools.removeTags(props.reqDetails)}
        styles={diffStyles}
        compareMethod={DiffMethod.WORDS}
        splitView={true}
        //showDiffOnly={true}
        //extraLinesSurroundingDiff={0}
      />
    );
  };

  /*const tab4Content = () => {
    let displayLines = [
      <Typography key="default" sx={{ backgroundColor: "white" }}>
        No changes found
      </Typography>,
    ];
    if (props.changeLog) {
      const changeLines = props.changeLog.split("||");
      changeLines.sort(
        (a, b) =>
          parseInt(b.substring(0, b.indexOf("|"))) -
          parseInt(a.substring(0, a.indexOf("|"))),
      );

      displayLines = changeLines.map((line, index) => {
        const changeDateTime = new Date(
          parseInt(line.substring(0, line.indexOf("|"))),
        );
        let changeInfo = line.substring(line.indexOf("|") + 1);
        changeInfo = changeInfo.replace(":c:", " changed ");
        if (changeInfo.indexOf(":t:") >= 0) {
          changeInfo = changeInfo.replace(":f:", " from ");
          changeInfo = changeInfo.replace(":t:", " to ");
        } else {
          changeInfo = changeInfo.replace(":f:", " ");
        }
        changeInfo = changeInfo.replace(":o:", " on ");
        let bgColor = "gainsboro";
        if (index % 2 == 0) {
          bgColor = "white";
        }
        const formattedLine = (
          <Typography key={index} sx={{ backgroundColor: bgColor }}>
            {changeInfo}
          </Typography>
        );
        return formattedLine;
      });
    }
    return (
      <Box
        sx={{
          border: "solid 1px",
          height: "300px",
          textAlign: "left",
          overflowY: "scroll",
        }}
      >
        {displayLines}
      </Box>
    );
  };
  */

  const tab4Content = () => {
    return <ChangeLogIndividualListComponent changeLog={props.changeLog} />;
  };

  return (
    <Box>
      <TabComponent
        ref={(tabRef) => (tabComponentRef.current = tabRef)}
        heightAdjustMode="Fill"
        className="requirementsTab"
        headerPlacement="Top"
        sx={{ textAlign: "left" }}
      >
        <TabItemsDirective>
          <TabItemDirective
            className="requirementsTab"
            header={{
              text: props.showComparisons ? "Requirement Details" : "Details",
            }}
            content={tab1Content}
          />
          {props.showComparisons ? (
            <TabItemDirective
              className="requirementsTab"
              header={{ text: "Comparison to previous version" }}
              content={tab2Content}
            />
          ) : null}
          {props.showComparisons ? (
            <TabItemDirective
              className="requirementsTab"
              header={{ text: "Comparison to last approved version" }}
              content={tab3Content}
            />
          ) : null}
          <TabItemDirective
            className="requirementsTab"
            header={{ text: "Change Log" }}
            content={tab4Content}
          />
        </TabItemsDirective>
      </TabComponent>
    </Box>
  );
}

export default RequirementsEditor;

RequirementsEditor.propTypes = {
  handleEditorContentsChange: PropTypes.func,
  reqDetails: PropTypes.string,
  prevDetails: PropTypes.string,
  height: PropTypes.string,
  showComparisons: PropTypes.bool,
  changeLog: PropTypes.string,
};
